import(/* webpackMode: "eager" */ "/var/www/chaivio-web-ecart/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/var/www/chaivio-web-ecart/public/css/about.css")